<div class="dashboard-metrics" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="40px">
  <mat-tab-group
    mat-stretch-tabs
    dynamicHeight
    fxLayout="column"
    fxLayoutAlign="center"
    fxFill
    (selectedTabChange)="onMetricsTabChange($event)"
  >
    <mat-tab [label]="METRICS_PAGE_TABS.PREVIEW | uppercase"></mat-tab>
    <mat-tab [label]="METRICS_PAGE_TABS.DOWNLOAD | uppercase"></mat-tab>
  </mat-tab-group>

  <div fxLayout="column">
    <div *ngIf="tab === METRICS_PAGE_TABS.PREVIEW">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="dashboard-metrics__title" fxLayout="row" fxLayoutAlign="space-between center">Metrics</div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="40px">
          <mat-checkbox [checked]="showTimings" (change)="setShowTimings($event.checked)">Show timings</mat-checkbox>
          <mat-form-field appearance="fill">
            <mat-label>Intervention</mat-label>
            <mat-select (selectionChange)="updateMetricsPreview($event?.source?.value, null)">
              <mat-option *ngFor="let intervention of filterInterventions" [value]="intervention">
                {{ intervention?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Module</mat-label>
            <mat-select
              (selectionChange)="updateMetricsPreview(null, $event?.source?.value)"
              [disabled]="!selectedIntervention"
              [(ngModel)]="resetModules"
            >
              <mat-option [value]="{ id: 0 }">All</mat-option>
              <mat-option *ngFor="let module of filterModules" [value]="module">
                {{ module?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Participant</mat-label>
            <mat-select
              (selectionChange)="setSelectedParticipant($event?.source?.value)"
              [disabled]="!selectedIntervention"
              [(ngModel)]="resetParticipants"
            >
              <mat-option [value]="-1">All</mat-option>
              <mat-option
                *ngFor="let participant of filterParticipants"
                [value]="participant?.participant_id ? participant?.participant_id : participant?.id"
              >
                {{ participant?.participant_id ? participant?.participant_id : participant?.id }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="selectedStudy?.type === StudyType.TIIM">
            <button
              mat-raised-button
              fxFlexAlign="top"
              color="accent"
              [disabled]="
                !(selectedIntervention && selectedParticipant) || selectedAllInterventions || selectedAllParticipants
              "
              (click)="downloadData(selectedIntervention?.id, selectedParticipant?.id)"
            >
              {{ 'Download' | uppercase }}
            </button>
          </div>
          <mat-slide-toggle
            *ngIf="selectedStudy?.type === StudyType.CC"
            [checked]="displayUnansweredQuestions"
            (change)="changeTableView($event.checked)"
          >
            Show unanswered module item questions
          </mat-slide-toggle>
        </div>
      </div>
      <ng-container *ngIf="displayUnansweredQuestions; else answeredQuestionsTable">
        <dashboard-unanswered-metrics-preview [selectedStudy]="selectedStudy"> </dashboard-unanswered-metrics-preview>
      </ng-container>
      <ng-template #answeredQuestionsTable>
        <dashboard-metrics-preview
          [selectedStudy]="selectedStudy"
          [showTimings]="showTimings"
          [selectedLanguage]="selectedLanguage"
          [participants]="participants"
          [participantIndex]="participantIndex"
        ></dashboard-metrics-preview>
      </ng-template>
    </div>
    <div *ngIf="tab === METRICS_PAGE_TABS.DOWNLOAD">
      <dashboard-metrics-download [selectedStudy]="selectedStudy"></dashboard-metrics-download>
    </div>
    <div *ngIf="tab === METRICS_PAGE_TABS.GRAPHS" fxLayout="column" fxLayoutGap="50px" fxLayoutAlign="center">
      <!--      TODO: Implement graphs tab -->
    </div>
  </div>
</div>
